import React from 'react'
import './loader.css'

function Loader() {

    return(
        <div
            className="loader"
        >
            <div className="item" />
            <div className="item" />
            <div className="item" />
        </div>
    )
}

export default Loader;